import { UserTypeIds } from "app/slices/user/UserModel";
import { selectCurrentUser } from "app/slices/user/userSlice";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router";

export default function ProtectedRoute() {
  const userType = useSelector(selectCurrentUser).userTypeId;
  if (userType === UserTypeIds.Default) {
    return <Navigate to={"/not-signed-in"}></Navigate>;
  }
  return <Outlet />;
}
